import { TransactionHistoryTable } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `PaymentTransactionListComponent`. */
export function PaymentTransactionsPage() {
  return (
    <div>
      <h1>Transactions</h1>
      <TransactionHistoryTable payment={paymentClient} />
    </div>
  )
}
